import AnnouncementSearch from './AnnouncementSearch';

export default AnnouncementSearch;
